<div
  class="relative frm-image {{ styleClass }}"
  [ngStyle]="style">
  <img
    [src]="src"
    [alt]="alt"
    [style.height]="height"
    [style.width]="width"
    [class]="imageClass"
    [style]="imageStyle" />

  <div
    class="frm-image-hover absolute top-0 left-0 h-full w-full z-5"
    [class.cursor-pointer]="preview || isShowIndicator"
    (click)="preview ? (visible = true) : onClickImage.emit()">
    <ng-container *ngIf="isShowIndicator">
      <ng-container *ngIf="indicatorTemplate; else defaultIndicatorTemplate">
        <ng-template [ngTemplateOutlet]="indicatorTemplate"></ng-template>
      </ng-container>
      <ng-template #defaultIndicatorTemplate>
        <div class="flex align-items-center h-full justify-content-center w-full bg-black-alpha-40">
          <i class="pi pi-eye text-white"></i>
        </div>
      </ng-template>
    </ng-container>
  </div>
</div>

<crm-galleria
  [(visible)]="visible"
  [images]="[{ src: src, alt: alt, id: src }]"
  [appendTo]="appendTo"></crm-galleria>
